import { AppTheme } from 'types';
import { api } from 'utilities/api.axios';

const BASE_URL = 'api/themes';

export const getThemes = async (): Promise<AppTheme[]> => api.get(BASE_URL);

export const getTheme = async (sector: string): Promise<AppTheme> =>
  api.get(`${BASE_URL}/${sector}`);
